export const ST_WORKFLOW_IS_CONFIRMATION_MODAL = "ST_WORKFLOW_IS_CONFIRMATION_MODAL"